import React from "react";
import { Control, UseFormWatch } from "react-hook-form";
import { choicesConfig, FieldOption } from "./pollConfig";
import { renderField } from "./fieldRenderers";
import { SurveyAnswers } from "@core/types";

interface DynamicFieldsProps {
  control: Control<SurveyAnswers>;
  watch: UseFormWatch<SurveyAnswers>;
}

const DynamicFields = ({ control, watch }: DynamicFieldsProps) => {
  const selectedChoices = watch("choice") || [];
  if (!selectedChoices.length) return null;

  const allowSelectTheSameTime = selectedChoices.filter(
    (choiceId: string) => choicesConfig.find((choice) => choice.id === choiceId)?.allowSelectTheSameTime
  );

  let fieldsToRender: FieldOption[];

  if (allowSelectTheSameTime.length > 1) {
    const uniqueFields = new Map<string, FieldOption>();
    allowSelectTheSameTime.forEach((choiceId: string) => {
      const choice = choicesConfig.find((config) => config.id === choiceId);
      choice?.fields.forEach((field) => {
        if (!uniqueFields.has(field.name)) {
          uniqueFields.set(field.name, field);
        }
      });
    });
    fieldsToRender = Array.from(uniqueFields.values());
  } else {
    const selectedChoice = choicesConfig.find((config) => config.id === selectedChoices[0]);
    fieldsToRender = selectedChoice?.fields || [];
  }

  return (
    <>
      {fieldsToRender.map((field) => (
        <div key={field.name} className="my-2">
          {renderField(field, control, watch)}
        </div>
      ))}
    </>
  );
};

export default DynamicFields;
